module.exports = __webpack_public_path__ + "static/img/home_foodgrade.80e65be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/home_foodgrade.png
// module id = 80
// module chunks = 0